import { useEffect } from 'react';
import { Table, useFilters } from '@ui/src';
import {
  amlAccountsColumns,
  amlAccountsColumnsLabels,
  amlAccountsFiltersSchema,
} from '../../../hoc/individual/variables/aml-accounts';
import { OverviewStatementsTransactionTypes } from './types';

import cn from '../overview-statements/overview-statements.module.css';

const AmlStatementsTransaction = ({
  onSort,
  onFilter,
  data,
  filters,
  sort,
  requestInProgress,
  setPage,
  pagination,
  errorList,
}: OverviewStatementsTransactionTypes): React.JSX.Element => {
  const { filtersComponent, handleSubmit, reset } = useFilters({
    filtersSchema: amlAccountsFiltersSchema,
    filters,
    onFilterChange: onFilter,
  });

  useEffect(() => {
    reset(filters);
  }, [filters, reset]);

  return (
    <Table
      columns={amlAccountsColumns}
      data={data || []}
      onSort={(name) => onSort(name)}
      filters={filters}
      sort={sort}
      setPage={(page) => setPage({ ...page, filters })}
      take="10"
      pagination={pagination}
      columnsLabels={amlAccountsColumnsLabels}
      onFilterChange={(values) => onFilter(values)}
      filtersComponent={filtersComponent}
      handleSubmit={handleSubmit}
      isLoading={requestInProgress}
      tableFormClassName={cn.overviewStatementsTableForm}
      tableHeadCellClassName={cn.overviewStatementsTableHeadCell}
      error={errorList}
      transactionTable
      clickable
    />
  );
};

export default AmlStatementsTransaction;
